import * as React from 'react';

function ProjectDashboardCardIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={86.526}
      height={72.36}
      viewBox='0 0 86.526 72.36'
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        id='Path_358'
        data-name='Path 358'
        d='M51.915,45.225H34.61a4.428,4.428,0,0,0-4.326,4.522v18.09A4.428,4.428,0,0,0,34.61,72.36H51.915a4.428,4.428,0,0,0,4.326-4.522V49.747A4.428,4.428,0,0,0,51.915,45.225ZM25.958,4.522A4.428,4.428,0,0,0,21.631,0H4.326A4.428,4.428,0,0,0,0,4.522v18.09a4.428,4.428,0,0,0,4.326,4.522H17.267l9.891,18.1A8.567,8.567,0,0,1,34.61,40.7h.038l-8.69-15.9V18.09H56.242V9.045H25.958ZM82.2,0H64.894a4.428,4.428,0,0,0-4.326,4.522v18.09a4.428,4.428,0,0,0,4.326,4.522H82.2a4.428,4.428,0,0,0,4.326-4.522V4.522A4.428,4.428,0,0,0,82.2,0Z'
        fill='#fff'
      />
    </svg>
  );
}
export default ProjectDashboardCardIcon;
